<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="clearfix flex justify-between">
          <span>{{$t('viewServiceInfo.title')}}</span>
          <div style="float: right;">
            <el-button 
              v-if="viewServiceInfo.index !== 2" 
              type="primary" 
              size="small"
              style="margin-right:10px;" 
              @click="_openSelectServiceInfoModel()"
            >
              <i class="el-icon-search"></i>
              {{$t('viewServiceInfo.selectService')}}
            </el-button>
            <el-button 
              v-if="viewServiceInfo.index !== 2" 
              type="primary" 
              size="small"
              @click="_openAddServiceInfoModel()"
            >
              <i class="el-icon-plus"></i>
              {{$t('viewServiceInfo.addService')}}
            </el-button>
          </div>
        </div>
        <div class="ibox-content">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.serviceId')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.serviceId}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.serviceName')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.name}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.serviceCode')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.serviceCode}}</label>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.messageQueue')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.messageQueueName}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.isInstance')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.isInstance}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.url')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.url}}</label>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.method')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.method}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.timeout')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.timeout}}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{$t('viewServiceInfo.retryCount')}}：
                </label>
                <label class="el-form-item__content">{{viewServiceInfo.retryCount}}</label>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-col>
    
    <choose-service 
      ref="chooseService"
      :emit-choose-service="'viewServiceInfo'"
      :emit-load-data="'viewServiceInfo'"
    ></choose-service>
    
    <add-service 
      ref="addService"
      :call-back-listener="'viewServiceInfo'"
      :call-back-function="'chooseService'"
    ></add-service>
  </el-row>
</template>

<script>
import ChooseService from '@/components/dev/chooseService/chooseService'
import AddService from '@/components/dev/addService/addService'

export default {
  name: 'ViewServiceInfo',
  components: {
    ChooseService,
    AddService
  },
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      viewServiceInfo: {
        index: 0,
        serviceId: "",
        flowComponent: 'Service',
        name: "",
        serviceCode: "",
        messageQueueName: "",
        isInstance: "",
        url: "",
        method: "",
        timeout: "",
        retryCount: ""
      }
    }
  },
  created() {
  },
  methods: {
    _openSelectServiceInfoModel() {
      this.$refs.chooseService.open()
    },
    _openAddServiceInfoModel() {
      this.$refs.addService.open()
    },
    onIndex(index) {
      this.viewServiceInfo.index = index
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}
.el-form-item__label {
  font-weight: bold;
}
.el-form-item__content {
  margin-left: 10px;
}
</style>